const UPDATE_STATUS = 'scratch-gui/connection/UPDATE_STATUS';
const UPDATE_VERSION = 'scratch-gui/connection/UPDATE_VERSION';

const initialState = {
    status: false,
    version: '0'
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_STATUS:
        return Object.assign({}, state, {
            status: action.status
        });
    case UPDATE_VERSION:
        return Object.assign({}, state, {
            version: action.version
        });
    default:
        return state;
    }
};

const updateStatus = function (status) {
    return {
        type: UPDATE_STATUS,
        status: status
    };
};

const updateVersion = function (version) {
    return {
        type: UPDATE_VERSION,
        version: version
    };
};

export {
    reducer as default,
    initialState as connectionInitialState,
    updateStatus,
    updateVersion
};
